import FormikDatePicker from "../../../Common/FormFields/DatePicker";
import FormikDropDown from "../../../Common/FormFields/FormikDropDown";
import FormikTimePicker from "../../../Common/FormFields/FormikTimePicker";
import RadioButton from "../../../Common/FormFields/RadioButton";
import { FormGroup } from "reactstrap";
import { useSelector } from "react-redux";
import moment from "moment";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import { useState } from "react";
import { useEffect } from "react";
import InputTimePicker from "../../../Common/FormFields/InputTimePicker";
const GameSchedule = ({
  formik,
  myref,
  isRadioSelected,
  handleRadioClick,
  setTime,
  pageState,
}) => {
  const weekList = useSelector((state) => state.loggedInUser.weekList);
  const opponentSchoolList = useSelector(
    (state) => state.loggedInUser.schoolList
  );
  const isEditSchedule = useSelector(
    (state) => state.loggedInUser.isEditSchedule
  );
  const scheduleInformation = useSelector(
    (state) => state.loggedInUser.scheduleInformation
  );
  const currentSeason = useSelector(
    (state) => state.loggedInUser.currentSeason
  );
  const [weekName, setWeekName] = useState(
    pageState.data.length > 0 ? "" : "WEEK 0"
  );
  const [opponentName, setOpponentName] = useState(
    isEditSchedule ? scheduleInformation.opponent.schoolName : ""
  );

  useEffect(() => {
    if (isEditSchedule) {
      getWeekName(scheduleInformation.seasonWeek.id);
    }
  }, []);

  const getWeekName = (id) => {
    weekList?.map((item) => {
      if (item.id === id) {
        setWeekName(item.title);
      }
    });
  };

  const ondateSet = (date) => {
    myref.current.setFieldValue("eventDate", date);
    myref.current.setFieldError("eventDate", "");
  };

  const maxDate = () => {
    const maxYear = currentSeason?.years?.substring(7, 13);
    const maxDate = new Date(maxYear, 11, 31);
    return maxDate;
  };

  const minDate = () => {
    const minYear = currentSeason?.years?.substring(0, 4);
    let minDate = new Date();
    if (Number(minYear) > new Date().getFullYear()) {
      minDate = new Date(minYear, 0, 1);
    }
    return minDate;
  };

  return (
    <div>
      <FormGroup>
        <label className="fmlabel mt-6 semi-bold">
          Week <span className="redstar">*</span>
        </label>
        <CustomDropDown
          selected={weekName}
          setSelected={setWeekName}
          formik={formik}
          fieldName="week"
          defaultSelectOption="Select Week"
          options={weekList}
          fieldToShow="title"
          optionValue="id"
          isWeek={true}
          isDisabled={"weekAllocated"}
          optionLength={weekList?.length}
        />
      </FormGroup>

      <FormGroup>
        <label className="fmlabel mt-6 semi-bold">
          Event type <span className="redstar">*</span>
        </label>
        <div className="d-flex flex-direction-r gap-20">
          <RadioButton
            label="Regular Season"
            value="Regular Season"
            isRadioSelected={isRadioSelected}
            stateToCompare={formik.values.eventType}
            setState="eventType"
            fieldName="eventType"
            handleRadioClick={handleRadioClick}
          />

          <RadioButton
            label="Post Season"
            value="Post Season"
            isRadioSelected={isRadioSelected}
            stateToCompare={formik.values.eventType}
            setState="eventType"
            fieldName="eventType"
            handleRadioClick={handleRadioClick}
          />

          <RadioButton
            label="Scrimmage"
            value="Scrimmage"
            isRadioSelected={isRadioSelected}
            stateToCompare={formik.values.eventType}
            setState="eventType"
            fieldName="eventType"
            handleRadioClick={handleRadioClick}
          />

          <RadioButton
            label="Tournament"
            value="Tournament"
            isRadioSelected={isRadioSelected}
            stateToCompare={formik.values.eventType}
            setState="eventType"
            fieldName="eventType"
            handleRadioClick={handleRadioClick}
          />
        </div>
        <div className="errorMsg fs-14 medium">
          {formik.touched.eventType && formik.errors.eventType}
        </div>
      </FormGroup>

      <FormGroup>
        <label className="fmlabel mt-6 semi-bold">
          Location <span className="redstar">*</span>
        </label>
        <div className="d-flex flex-direction-r gap-20">
          <RadioButton
            label="Home"
            value="Home"
            isRadioSelected={isRadioSelected}
            stateToCompare={formik.values.location}
            setState="location"
            fieldName="location"
            handleRadioClick={handleRadioClick}
          />

          <RadioButton
            label="Away"
            value="Away"
            isRadioSelected={isRadioSelected}
            stateToCompare={formik.values.location}
            setState="location"
            fieldName="location"
            handleRadioClick={handleRadioClick}
          />

          <RadioButton
            label="Neutral"
            value="Neutral"
            isRadioSelected={isRadioSelected}
            stateToCompare={formik.values.location}
            setState="location"
            fieldName="location"
            handleRadioClick={handleRadioClick}
          />
        </div>
        <div className="errorMsg fs-14 medium">
          {formik.touched.location && formik.errors.location}
        </div>
      </FormGroup>

      <FormGroup>
        <label className="fmlabel mt-6 semi-bold noWrap">
          Select Opponent <span className="redstar">*</span>
        </label>
        <CustomDropDown
          selected={opponentName}
          setSelected={setOpponentName}
          formik={formik}
          fieldName="opponent"
          defaultSelectOption="Select Opponent"
          options={opponentSchoolList}
          fieldToShow="schoolName"
          optionValue="schoolName"
        />
      </FormGroup>

      <div className="two-column-row">
        <FormGroup>
          <label className="fmlabel mt-6 semi-bold ">
            Event Date <span className="redstar">*</span>
          </label>

          <FormikDatePicker
            formik={formik}
            fieldName="eventDate"
            onChange={ondateSet}
            startDate={formik.values.eventDate}
            minDate={minDate()}
            maxDate={maxDate()}
          />
        </FormGroup>

        <FormGroup>
          <label className="fmlabel mt-6 semi-bold ">
            Event Time <span className="redstar">*</span>
          </label>
          <InputTimePicker
            formik={formik}
            fieldName="eventTime"
            onChange={setTime}
            time={formik.values.eventTime}
          />
          <div className="errorMsg fs-14 medium">
            {formik.touched.eventTime && formik.errors.eventTime}
          </div>
        </FormGroup>
      </div>
    </div>
  );
};

export default GameSchedule;
